import { HealthBadge } from '../components/HealthBadge';

/**
 * Operator status page (spec 001, SC-100..103). The scaffold's health badge lives here now that the
 * public Home is the association's front door — an operator/uptime view, not public marketing.
 */
export default function Status() {
  return (
    <div className="mx-auto flex w-full max-w-xl flex-col items-center gap-8 px-6 py-24 text-center">
      <div className="space-y-2">
        <p className="font-display text-xs font-semibold uppercase tracking-[0.28em] text-accent-deep">
          Operator
        </p>
        <h1 className="font-display text-2xl font-semibold uppercase tracking-[0.12em] text-ink">
          Platform status
        </h1>
      </div>
      <HealthBadge />
      <p className="max-w-prose font-sans text-sm text-muted">
        Live health of the backend and its database. This page is for operators; members and visitors use
        the public site.
      </p>
    </div>
  );
}
